import EmptyState from '../components/EmptyState';

export default function Numbers() {
  return (
    <EmptyState
      title="Numbers"
      description="Number system reference across target languages"
    />
  );
}
